


import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography, Grid, Paper, Avatar, List, ListItem, ListItemIcon, ListItemText, Button } from '@mui/material';
import { Email, Person, Work, AttachMoney, VerifiedUser, ExitToApp } from '@mui/icons-material';
import { logout } from  '../redux/actions/authActions';
import { actionButtonStyles } from "../styles/actionButton";
import { windowsTableStyles } from "../styles/windowsTableStyles";
import { textFieldStyles } from "../styles/textFieldStyles";
import BreadcrumbNav from "../components/BreadcrumbNav";
import { largeBold, largeTitle, mediumTitle, smallTitle, thinTitle, xlBold } from '../styles/typography';

// Static role translations - defined outside component to prevent re-renders
const ROLE_TRANSLATIONS = {
  'Assistant Lawyer': {
    en: 'Assistant Lawyer',
    nl: 'Assistent-advocaat'
  },
  'Responsible Lawyer': {
    en: 'Responsible Lawyer', 
    nl: 'Verantwoordelijke advocaat'
  },
  'Manager': {
    en: 'Manager',
    nl: 'Manager'
  }
};

const ProfilePage = () => {
  const { t, i18n } = useTranslation(['pages', 'common', 'buttons', 'forms']);

  const breadcrumbs = [
    { label: t('navigation:breadcrumb.home'), href: "/" },
  ];
  const tableStyles = windowsTableStyles();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userLoaded);

  // Safe role translation function - uses static translations
  const translateRole = (role) => {
    const currentLang = i18n.language || 'en';
    const roleTranslation = ROLE_TRANSLATIONS[role];
    if (roleTranslation && roleTranslation[currentLang]) {
      return roleTranslation[currentLang];
    }
    return role; // fallback to original role
  };

  const handleLogout = () => {
    dispatch(logout());
    // Check if we're in production or development
    const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
    const loginUrl = isProduction ? 'https://lawpro.nl/login' : 'http://localhost:3000/login';
    window.location.href = loginUrl;
  }; 

  if (!user) {
    return <Typography variant="h6">Loading...</Typography>;
  }

  return (
    <Container maxWidth="lg" sx={{
      backgroundColor: "white",
      boxShadow: "0px 4px 16px rgba(0,0,0,0.013)", // Reduced shadow spread
      pt: 2,
      marginBottom: 8,
      marginTop: 2,
    }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0",
          margin: "0",
          mb: 4,
          mt: 2,
          gap: 2,
        }}
      >
        <BreadcrumbNav title={t('pages:profile.title')} breadcrumbs={breadcrumbs} />

       
{/* 
        <Button
          startIcon={<AddIcon />}
          onClick={() => navigate("/timesheets/create")}
          size="small"
          sx={actionButtonStyles()}
        >
          Create Timesheet
        </Button> */}
      </Box>
      <Box elevation={3} style={{ padding: '20px', marginTop: '20px' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4} sx={{display: "flex", flexDirection:"row", alignItems:"center"}}>
            <Avatar alt={user.firstName} src={user.avatar ? user.avatar : "/static/images/avatar/1.jpg"} style={{ width: '100px', height: '100px', margin: 'auto' }} />
            <Box>
            <Typography variant="h4" sx={xlBold}>{`${user.firstName} ${user.lastName}`}</Typography>
            <Typography variant="subtitle1" sx={thinTitle}>{translateRole(user.role)}</Typography>
          
            </Box>
            
          </Grid>
          
        </Grid>
        <List sx={{marginTop: 4}}>
          <ListItem>
            <ListItemIcon>
              <Email />
            </ListItemIcon>
            <ListItemText primary={t('forms:labels.email')} secondary={user.email} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Person />
            </ListItemIcon>
            <ListItemText primary={t('forms:labels.fullName')} secondary={`${user.firstName} ${user.middleName ? user.middleName + ' ' : ''}${user.lastName}`} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Work />
            </ListItemIcon>
            <ListItemText primary={t('forms:labels.role')} secondary={translateRole(user.role)} />
          </ListItem>
          {/* <ListItem>
            <ListItemIcon>
              <AttachMoney />
            </ListItemIcon>
            <ListItemText primary="Hourly Rate" secondary={`€${user.hourlyRate ? user.hourlyRate : 0}`} />
          </ListItem> */}
          <ListItem>
            <ListItemIcon>
              <VerifiedUser />
            </ListItemIcon>
            <ListItemText primary={t('forms:labels.active')} secondary={user.isActive ? t('common:yes') : t('common:no')} />
          </ListItem>
        </List>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button size="small"
          sx={actionButtonStyles()} startIcon={<ExitToApp />} onClick={handleLogout}>
            {t('common:logout')}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ProfilePage;
